export const formatFileSize = (bytes: number, decimal: number = 2): string => {
  if (bytes === 0) {
    return '0 bytes';
  }

  const kilobyte = 1024;
  const sizes = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const sizeIndex = Math.floor(Math.log(bytes) / Math.log(kilobyte));

  return `${(bytes / Math.pow(kilobyte, sizeIndex)).toFixed(decimal)} ${sizes[sizeIndex]}`;
};
